// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const TryPremiumContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-trypremiumcontainer" */ "./TryPremiumContainer")).then((bundle)=>{
        return {
            default: bundle.TryPremiumModalContainer
        };
    });
export const LazyTryPremiumContainer = /*#__PURE__*/ lazy(TryPremiumContainerLazyLoader);
